<div class="ibox detailed-view-ibox">
    <div class="detailed-view-header">
        <span class="building-name">{{company.name}}</span>
        <span class="close-detailed-view" (click)="close()">×</span>
    </div>

    <div class="detailed-view-body">
        <div class="detailed-view__more-info">
            <form #form="ngForm" [ngClass]="{'ng-submitted': form.submitted}">
                <div class="row company-view m-t-md m-b-md">
                    <div class="col-md-4">
                        <div class="circle-logo">
                            <img *ngIf="theme.logo" [src]="theme.logo"/>
                        </div>
                    </div>

                    <div class="col-md-8 company-main-info">
                        <input-field name="name"
                                     [ngModel]="company.name"
                                     [class]="'strong'"
                                     (update)="update('name', form.value.name)">
                        </input-field>

                        <input-field name="email"
                                     [ngModel]="company.email"
                                     (update)="update('email', form.value.email)">
                        </input-field>

                        <input-field name="address"
                                     [ngModel]="company.address"
                                     (update)="update('address', form.value.address)">
                        </input-field>

                        <input-field name="phone"
                                     [ngModel]="company.phone"
                                     (update)="update('phone', form.value.phone)">
                        </input-field>

                        <input-field name="primaryContact"
                                     [ngModel]="company.primaryContact"
                                     (update)="update('primaryContact', form.value.primaryContact)">
                        </input-field>

                        <action-button [data]="company" (onClick)="onActionClick($event)"></action-button>
                    </div>
                </div>

                <hr>

                <div class="m-b-sm">
                    <input-field name="emailSenderName"
                                 [title]="'Sender Name'"
                                 [ngModel]="emailSenderSettings.emailSenderName"
                                 (update)="updateSenderSettings({emailSenderName: form.value.emailSenderName})">
                    </input-field>
                </div>

                <div class="m-b-sm">
                    <input-field name="emailSender"
                                 #emailInput
                                 [title]="'Sender Email'"
                                 [ngModel]="emailSenderSettings.emailSender"
                                 (update)="updateEmailSender({emailSender: form.value.emailSender}, emailInput)">
                    </input-field>
                </div>

                <hr/>

                <div class="radio-tabs clearfix m-b-md">
                    <input type="radio" name="activeTab" id="offices" [value]="'offices'" [(ngModel)]="activeTab">
                    <label class="col-md-4" for="offices">Offices</label>

                    <input type="radio" name="activeTab" id="UI" [value]="'UI'" [(ngModel)]="activeTab">
                    <label class="col-md-4" for="UI">User Interface</label>

                    <input type="radio" name="activeTab" id="settings" [value]="'settings'" [(ngModel)]="activeTab">
                    <label class="col-md-4" for="settings">Settings</label>
                </div>

                <div class="tab offices" *ngIf="activeTab === 'offices'">
                    <p class="strong" *ngIf="!company.offices.length">No offices in this company</p>

                    <div *ngFor="let office of company.offices">
                        <div class="row m-b-sm show-fa-in-hover">
                            <div class="col-md-6 strong">{{office.name}}</div>

                            <div class="col-md-4">{{formatPhone(office.phone)}}</div>

                            <div class="col-md-2 crud-icon">
                                <i (click)="onActionClick({type: 'removeOffice', data: office})"
                                   class="fa fa-trash pull-right"
                                   title="Delete">
                                </i>

                                <i (click)="onActionClick({type: 'editOffice', data: office})"
                                   class="fa fa-pencil pull-right"
                                   title="Edit">
                                </i>
                            </div>
                        </div>

                        <div class="row m-b-md" *ngFor="let member of office.members">
                            <div class="col-md-5 col-md-offset-1 strong">{{member.name}}</div>

                            <div class="col-md-6">{{formatPhone(member.phone)}}</div>
                        </div>

                        <hr>
                    </div>
                </div>

                <div class="tab" *ngIf="activeTab === 'UI'">
                    <div class="square-logo"><img *ngIf="theme.logo" [src]="theme.logo"></div>

                    <select-field [ngModel]="company.theme"
                                  name="theme"
                                  [title]="'COLOR THEME'"
                                  [optionTitleKey]="'name'"
                                  [data]="themesList"
                                  (update)="update('theme', form.value.theme)">
                    </select-field>

                    <hr>

                    <div class="m-b-xs">
                        <div class="color-view" [style.background]="theme.colors.body"></div>
                        <span class="strong">Background color</span>
                    </div>

                    <div class="m-b-xs">
                        <div class="color-view" [style.background]="theme.colors.primary"></div>
                        <span class="strong">Primary color</span>
                    </div>

                    <div class="m-b-xs">
                        <div class="color-view" [style.background]="theme.colors.primaryHover"></div>
                        <span class="strong">Primary hover color</span>
                    </div>

                    <div class="m-b-xs">
                        <div class="color-view" [style.background]="theme.colors.menuBackgroundColor"></div>
                        <span class="strong">Menu Background Color</span>
                    </div>

                    <div class="m-b-xs">
                        <div class="color-view" [style.background]="theme.colors.menuFontColor"></div>
                        <span class="strong">Menu Font Color</span>
                    </div>

                    <div class="m-b-xs">
                        <div class="color-view" [style.background]="theme.colors.selectedMenuItemFontColor"></div>
                        <span class="strong">Selected Menu Item Font Color</span>
                    </div>
                </div>

                <div class="tab" *ngIf="activeTab === 'settings'">

                    <div class="m-b-sm">
                        <span class="mtv-primary-color clickable-text" (click)="companyNotificationTemplateEmail('invitation')">
                            Invitation Email
                        </span>
                    </div>
                    <div class="m-b-sm">
                        <span class="mtv-primary-color clickable-text" (click)="companyNotificationTemplateEmail('reset_password')">
                            Reset Password Email
                        </span>
                    </div>

                    <input-field name="loginpage"
                                 title="Log In Page"
                                 [ngModel]="company.loginpage"
                                 (update)="update('loginpage', form.value.loginpage)">
                    </input-field>
                    <div *ngIf="form.value.loginpage">{{ 'https://web.maxcondoclub.com/#/'+form.value.loginpage }}</div>
                    <input-field name="logoutUrl"
                                 title="Log Out Page"
                                 [ngModel]="company.logoutUrl"
                                 (update)="update('logoutUrl', form.value.logoutUrl)">
                    </input-field>

                    <hr>

                    <div class="slide-auto-approve m-b-sm">
                        <mat-slide-toggle name="autoApproveResidentDataChanges"
                                        (change)="updateAutoApprove(form.value.autoApproveResidentDataChanges ? 1 : 0)"
                                        [ngModel]="managementCompany.companySettings.autoApproveResidentDataChanges">
                        </mat-slide-toggle>
                        <span>Auto Approve Resident Data Changes</span>
                    </div>

                </div>
            </form>
        </div>
        <spinner [spinnerShow]="autoApproveResidentLoading"></spinner>
    </div>
</div>




// WEBPACK FOOTER //
// /app/src/app/views/admin/management-company/company-view/company-view.component.html